module MonitoringRules {
    import IAllEnvironmentNames = Shared.Environments.IAllEnvironmentNames;
    "use strict";
    export class MonitoringRulesController {
        public rules: MonitoringRuleViewModel[];
        public emailRecipients: string;
        public emailRecipientsEdited: boolean;
        public initialEmailDataLoaded: boolean; //This should probably be done in the ui router as a resolve
        static $inject = ["$rootScope", "$http", "$stateParams", "$uibModal", "allEnvironmentNames", "allPromotedVariables", "systemTimeZones", "notifications","$state"];
        constructor(private $rootScope: ng.IRootScopeService, private $http: ng.IHttpService, public $stateParams: IMonitoringRulesStateParams,
            private $modal: angular.ui.bootstrap.IModalService,
            public allEnvironmentNames: IAllEnvironmentNames[],
            public allPromotedVariables: string[],
            public systemTimeZones: ITimeZoneInfo[],
            private notifications: INotifications,
            private $state) {
            if (!this.isEnvironmentParameterInEnvironments) {
                this.$state.go("environment", { environmentName: EnvironmentVariables.DEFAULT_ENV_NAME });
            }
            $rootScope.$broadcast("loadingspinner.manual.spin");
            this.updateData();
            this.getEmailRecipients();
        }

        get isEnvironmentParameterInEnvironments() : boolean {
          return _.some(this.allEnvironmentNames, x => x.name == this.$stateParams.environmentName);
        }

        updateData() {
            this.$http.get("MonitoringRules/GetRules", { params: { environmentName: this.$stateParams.environmentName } })
                .success((response: Frends.IJsonResponse) => {
                    this.$rootScope.$broadcast("loadingspinner.manual.stop");
                    if (response.success) {
                        var data = <IMonitoringRuleDataModel[]>response.data
                        this.rules = data.map(d => new MonitoringRuleViewModel(d.id, d.config, d.series, d.alertsCount))
                    }
                });
        }

        removeRule(rule: MonitoringRuleViewModel) {
            this.$modal.open({
                templateUrl: 'deleteConfirmationModalTemplate',
                windowClass: "default-modal-styles",
                resolve: {
                    itemType: () => FRENDS.Localizations.Rule,
                    itemName: () => ""
                },
                controller: Shared.DeleteConfirmationModalController,
                controllerAs: "ctrl"
            }).result.then(() =>
                this.$http.post("MonitoringRules/RemoveRule", {
                    id: rule.id
                }).success(() => this.updateData()));
        }

        addNewRule(newRule: MonitoringRuleViewModel) {
            newRule.environmentName = this.$stateParams.environmentName;
            this.$http.post("MonitoringRules/NewRule", {
                environmentName: this.$stateParams.environmentName,
                config: newRule
            }).success(() => this.updateData());
        }


        acknowledgeAlerts(rule: MonitoringRuleViewModel) {
            this.$http.post("MonitoringRules/AcknowledgeAlerts", {
                id: rule.id
            }).success(() => this.updateData());
        }

        getEmailRecipients() {
            this.$http.get("MonitoringRules/GetEmailRecipients", { params: { environmentName: this.$stateParams.environmentName } })
                .success((response: Frends.IJsonResponse) => {
                    if (response.success) {
                        var data = <string[]>response.data
                        this.emailRecipients = data.join();
                        this.initialEmailDataLoaded = true;
                    }
                });
        }

        editEmailRecipients() {
            this.$http.post("MonitoringRules/NewEmailRecipient", {
                environmentName: this.$stateParams.environmentName,
                emailRecipients: this.emailRecipients.split(',')
            }).success((result) => this.updateSuccessful(result));
        }

        updateSuccessful(result) {
            if (result.success == true) {
                this.notifications.notify(result.data);
                this.emailRecipientsEdited = false;
            }
     
        }

        cancelEmailEdit() {
            this.getEmailRecipients();
            this.emailRecipientsEdited = false;
        }

        getTimeZoneDescription(timeZoneId: string) {
            let tzInfo = _.find(this.systemTimeZones, tz => tz.id === timeZoneId);
            return tzInfo && tzInfo.description;
        }
    }

    module.controller("MonitoringRulesController", MonitoringRulesController);

    interface IMonitoringRulesStateParams extends angular.ui.IStateParamsService {
        environmentName: string;
    }

    interface ITimeZoneInfo {
        id: string,
        description: string
    }

}